import React from "react";
import "./ScrollIndicator.scss";

function ScrollIndicator() {
  return <div className="scrollIndicator"></div>;
}

export default ScrollIndicator;
